import footerJSON from "../../data/_footer.json";
import Vue from "vue";
import FormApi from "../../services/api/formApi.js";

const FormApiService = new FormApi();

export default {
  data() {
    return {
      data: [],
      email: "",
      isUserLogged: false,
      showSignUp: true,
    };
  },

  methods: {
    redirect,
    validateSubscription,
    submit,
  },

  beforeMount() {
    this.data = this.$utils.deepClone(footerJSON);
    for (let i = 0; i < this.data.length; i++) {
      Vue.set(this.data[i], "previewActive", false);
    }
  },
};

function redirect(title, item) {
  if (title === "follow" || item.name === "FAQ" || item.name === "Contact Us") {
    window.open(item.url, "_blank");
  } else {
    this.$router.push(item.url);
  }
}

function validateSubscription() {
  const _self = this;

  _self.$validator.validate().then((valid) => {
    if (!valid) {
      return false;
    }
    _self.submit();
  });
}

function submit() {
  FormApiService.submitHubspotEmail({
    fields: [
      {
        name: "email",
        value: this.email,
      },
    ],
    pageName: [
      {
        name: "footer",
        value: "footer",
      },
    ],
    url: {
      name: "url",
      value: window.location.href,
    },
  })
    .then(() => {
      this.errors.clear();
      this.$swal("Success", "You have successfully subscribed!").then(() => {
        this.showSignUp = false;
      });
    })
    .catch((error) => {
      this.$swal("Attention", error.response.data.error_message);
    });
}
